import {
  GetAllCountryLabelsQuery,
  GetTopCountryLabelsQuery,
} from '@/lib/graphql/generated/graphql';
import { atom } from 'jotai';

export type CountryLabel = GetAllCountryLabelsQuery['allCountryLabels'][number];

export const allCountryLabelsAtom = atom<CountryLabel[]>([]);
export const allCountryLabelsLoadingAtom = atom(false);
export const allCountryLabelsErrorAtom = atom<Error | undefined>(undefined);
// Keyed by StoreRegion value (e.g. 'Fr', 'Us')
export const topCountryLabelsByStoreAtom = atom<
  Partial<Record<string, GetTopCountryLabelsQuery['topCountryLabels']>>
>({});
